import { CLASSIFICATION_CUBE_NAME } from '@/api/hcp';
import { GetOptionsQueryFunction } from '@/types/cube';
import { FilterConfigDynamic } from '@/types/filter';
import { toStringOrNull } from '@/utils/cube';
import { PRODUCTS_FILTER_LIMIT } from '../../filterDefaultLimits';

const TAE_AREA_OPTIONS: GetOptionsQueryFunction = ({ sourceCube }) => ({
  dimensions: [`${sourceCube}.global_product_name`],
  limit: PRODUCTS_FILTER_LIMIT,
});

const productFilter: FilterConfigDynamic = {
  label: 'global.filters.formControls.productsLabel',
  sourceCube: CLASSIFICATION_CUBE_NAME,
  defaultValue: [],
  getOptionsQuery: TAE_AREA_OPTIONS,
  mapResult: result => {
    const value = toStringOrNull(result[`${CLASSIFICATION_CUBE_NAME}.global_product_name`]);
    if (value === null) return null;
    return { value, label: value };
  },
  type: 'multiselect',
  clearable: true,
  placeholder: 'global.filters.formControls.productsPlaceholder',
  format: ({ value }) => {
    const v = value as string;
    return v === 'other' ? 'Other' : v;
  },
  searchable: true,
  applyFilter: value => {
    const v = value as string;
    return {
      member: `${CLASSIFICATION_CUBE_NAME}.global_product_name`,
      operator: 'equals',
      values: [...v],
    };
  },
};

export default productFilter;
